/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, func, arrayOf, shape, array,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CallIcon from '@material-ui/icons/Call';
import ShopTheSiteBanner from '../../../pages/Account/components/GiftList/ShopTheSiteBanner';
import MobileFooterBlock from './MobileFooterBlock/MobileFooterBlock';

const styles = (theme) => ({
    mobileFooter: {
        display: 'block',
        position: 'relative',
        paddingBottom: 10,
    },
    textCenter: {
        textAlign: 'center',
    },
    foodMobileFooter: {
        marginTop: '50px',
        display: 'block',
        paddingBottom: 48,
        position: 'relative',
        '& a': {
            textDecoration: 'none',
            '&.call-info': {
                margin: '-28px 0 0 0',
                display: 'inline-block',
                '& svg': {
                    color: theme?.palette?.common?.white,
                    margin: '0 auto',
                    display: 'block',
                    padding: '10px 8px',
                    fontSize: '55px',
                    borderRadius: '50%',
                    backgroundColor: theme?.palette?.secondary?.main,
                },
                '& div': {
                    color: theme?.palette?.primary?.main,
                    padding: '5px 8px',
                    fontSize: '16px',
                },
            },
        },
    },
});
class MobileGraphqlFooter extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openDialog: false,
            title: '',
        };
    }

    setTitle(props) {
        if (props.self) {
            props.self.setState({
                title: props.title,
                openDialog: true,
            });
        } else {
            this.setState({
                title: props.title,
                openDialog: true,
            });
        }
    }

    setDialog(props) {
        if (props.self) {
            props.self.setState({
                openDialog: props.close,
            });
        } else {
            this.setState({
                openDialog: false,
            });
        }
    }

    mobileFooter = () => {
        const {
            classes, mobileFooterData, checkTitle, presentationFamily,
        } = this.props;
        const { openDialog, title } = this.state;
        const styleOverrides = {};
        const foodPresentation = (presentationFamily === 'food');
        const checkMobileMenuData = (foodPresentation) ? 'mobile' : 'defaultfooter';
        const defaultParamsMenuKey = (!foodPresentation) ? 'footer' : '';
        const activeMenuItem = mobileFooterData.filter((mobileFooterItem) => checkTitle(mobileFooterItem.title, checkMobileMenuData, defaultParamsMenuKey));
        if (activeMenuItem && activeMenuItem[0] && activeMenuItem[0]?.footer_blocks && activeMenuItem[0]?.footer_blocks.length > 0) {
            const blocks = activeMenuItem[0]?.footer_blocks;
            let popUpData = [];
            let footerData = [];
            let bottomLinks = [];
            blocks.forEach((footerBlockItem) => {
                bottomLinks = footerBlockItem?.footer_bottom_links?.link_group || bottomLinks;
                footerData = footerBlockItem?.menu_group_links?.menu_group_link_ref || footerData;
            });
            if (foodPresentation && footerData && footerData.length > 0) {
                styleOverrides.backgroundColor = footerData[0].background_color?.color;
            }
            if (bottomLinks && bottomLinks.length > 0) {
                popUpData = bottomLinks.filter((bottomLinkItem) => bottomLinkItem.popup === true);
            }
            return (
                <div className={(foodPresentation) ? classes.foodMobileFooter : classes.mobileFooter} style={styleOverrides}>
                    {(foodPresentation)
                    && (
                        <Grid container>
                            <Grid item xs={12} className={classes.textCenter}>
                                <Typography component="a" className="call-info" href="tel:1-877-455-7700">
                                    <CallIcon />
                                    <Typography component="div">
                                        Call
                                    </Typography>
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                    {blocks.map((block, index) => {
                        const keyItem = `mobileFooterBlock${index}`;
                        return (
                            <MobileFooterBlock
                                block={block}
                                self={this}
                                setDialog={this.setDialog}
                                setPopupTitle={this.setTitle}
                                key={keyItem}
                                bottomLinks={bottomLinks}
                                popUpData={popUpData}
                                openDialog={openDialog}
                                title={title}
                                presentationFamily={presentationFamily}
                            />
                        );
                    })}
                    <ShopTheSiteBanner />
                </div>
            );
        }
        return (<></>);
    }

    render() {
        return this.mobileFooter();
    }
}
MobileGraphqlFooter.defaultProps = {
    mobileFooterData: [],
};

MobileGraphqlFooter.propTypes = {
    mobileFooterData: arrayOf(
        shape({
            footer_blocks: array.isRequired,
            locale: string.isRequired,
            title: string.isRequired,
            uid: string.isRequired,
        }).isRequired,
    ),
    classes: object.isRequired,
    checkTitle: func.isRequired,
    presentationFamily: string.isRequired,
};

export default withStyles(styles)(MobileGraphqlFooter);
